import { createApp } from "vue";
import App from "./App.vue";
import $ from 'jquery';

import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueSweetalert2 from "vue-sweetalert2";
import VCalendar from "v-calendar";
import "v-calendar/style.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "bootstrap-datepicker";
// import { surveyPlugin } from "survey-vue3-ui";
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import 'qalendar/dist/style.css'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@/assets/style/site.css";
import "sweetalert2/dist/sweetalert2.min.css";
import VueHtmlToPaper from 'vue-html-to-paper';
import { enableDatePickerOnClick } from "@/utils/datePickerOnClick";
window.$ = $;
enableDatePickerOnClick();
createApp(App)
  .use(store)
  .use(router)
  .use(VueSweetalert2)
  .use(VCalendar, {})
  //.use(surveyPlugin)
  .use(VueHtmlToPaper)
  .mount("#app");

import "bootstrap/dist/js/bootstrap.js";
